import { ARTICLES_FF } from '@lumapps/articles/constants';
import { COMMUNITY_FEATURE_TOKEN } from '@lumapps/communities/constants';
import { isFeatureEnabled } from '@lumapps/features';
import { LEARNING_FF } from '@lumapps/learning/constants';
import { PLAY_VIDEO_FEATURE_TOKEN } from '@lumapps/play-core/constants';

import { JOURNEYS_ALPHA_FF, JOURNEYS_BETA_FF } from '../constants';

export const isJourneysAlphaEnabled = isFeatureEnabled(JOURNEYS_ALPHA_FF);
export const isJourneysBetaEnabled = isFeatureEnabled(JOURNEYS_BETA_FF);

// resources feature flags selectors
export const isCommunityFeatureEnabled = isFeatureEnabled(COMMUNITY_FEATURE_TOKEN);
export const isLearningFeatureEnabled = isFeatureEnabled(LEARNING_FF);
export const isVideoFeatureEnabled = isFeatureEnabled(PLAY_VIDEO_FEATURE_TOKEN);
export const isArticleFeatureEnabled = isFeatureEnabled(ARTICLES_FF);
